import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

import theme from './LogoutTimer.scss';
import {getMessage as msg} from 'MessageBundle'

export default class LogoutTimer extends React.Component {

    constructor(props) {
        super(props);
        // subtract -1 to retrieve 59:59, but not 00:00
        this.state = {
            expiration: new Date().getTime() + props.timeout - 1,
            remainingTime: props.timeout - 1
        };
    }

    componentDidMount() {
        const socket = new SockJS('/logout-timer');
        const client = Stomp.over(socket);

        client.debug = null; // disable debug logging

        const setExpiration = (message) => {
            this.setState({
                expiration: message.body
            });
        };
        client.connect({}, function (frame) {
            client.subscribe('/user/queue/logout-timer', setExpiration);
        });

        this.timerID = setInterval(
            () => this.calculateTimeLeft(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    calculateTimeLeft() {
        const remainingTime = this.state.expiration - new Date().getTime();

        if (remainingTime <= 0) {
            clearInterval(this.timerID);
            this.props.onTimeOver();
        } else {
            this.setState({
                remainingTime: remainingTime
            });
        }
    }

    render() {
        return (
            <span className={theme.logoutTimer} title={msg('navigationMenu.logoutTimerTitle')}>
              Restzeit <br /> {moment(new Date(this.state.remainingTime)).format("mm:ss")} Min
            </span>
        );
    }
}

LogoutTimer.propTypes = {
    /**
     * Timeout value in milliseconds after which {@link #onTimeOver} function has to be invoked.
     */
    timeout: PropTypes.number.isRequired,

    /**
     * Javascript function that has to be executed after expiration of {@link #timeout}.
     */
    onTimeOver: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/LogoutTimer/index.js